"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { SmileLinkEntryInput } from "@/lib/utils/smile-chrome/link-entries";

/**
 * The /smile header's nav entry (the Links of bbSmileHeaderNav), fetched once
 * on the server (app/[...slug]/page.tsx, app/smile/schedule/page.tsx) and
 * read by SmileHeaderWithContextDefault, so a canvas placement and the atom
 * inside the shared chrome slot render the same row the code fallback
 * renders from the entry. Absent (no provider, or nothing published) the atom
 * keeps its defaults and whatever the author bound on the canvas. The
 * SmileFooterEntryContext mirror.
 */
const SmileHeaderEntryContext = createContext<ReadonlyArray<SmileLinkEntryInput> | null>(null);

export function SmileHeaderEntryProvider({
	value,
	children,
}: {
	value: ReadonlyArray<SmileLinkEntryInput> | null;
	children: ReactNode;
}) {
	return (
		<SmileHeaderEntryContext.Provider value={value}>{children}</SmileHeaderEntryContext.Provider>
	);
}

export function useSmileHeaderNavEntry(): ReadonlyArray<SmileLinkEntryInput> | null {
	return useContext(SmileHeaderEntryContext);
}
